export default __webpack_public_path__ + "static/media/walletConnectIcon.1dbab988.svg";